import AppStoreBadge from './AppStoreBadge';

export default function CTA() {
  return (
    <section className="cta">
      <div className="container">
        <div className="cta-card">
          <h2>Translate your world.</h2>
          <p>Download Klingua free and start your next conversation in any language.</p>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <AppStoreBadge light />
          </div>
        </div>
      </div>
    </section>
  );
}
